module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "blockquote",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('div', {
    staticClass: "blockquote1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("After the Day of the Lie gather in select circles")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Shaking with laughter when our real deeds are mentioned")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('span', [_vm._v("Czesław Miłosz, ‘Child of Europe’")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e4dfa5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface003.vue
// module id = 75
// module chunks = 0